import { Component } from '@angular/core';
import {Modal} from '@softline/ui-core';


import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'lib-unsaved-changes-info-dialog',
    imports: [
    TranslatePipe
  ],
    templateUrl: './unsaved-changes-info-dialog.component.html',
    styleUrls: ['./unsaved-changes-info-dialog.component.css']
})
export class UnsavedChangesInfoDialogComponent implements Modal<'save' | 'discard'> {

  close!: (result: ('save' | 'discard')) => void;

  constructor() {}

  registerCloseHandler(handler: (result: ('save' | 'discard')) => void) {
    this.close = handler;
  }
}


